"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@mui/utils");
const paletteLight_1 = __importDefault(require("themes/paletteLight"));
const paletteDark_1 = __importDefault(require("themes/paletteDark"));
function createPalette(mode) {
    const basePalette = mode === 'light' ? paletteLight_1.default : paletteDark_1.default;
    return (0, utils_1.deepmerge)(basePalette, {
        mode,
    });
}
exports.default = createPalette;
